"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastBar = exports.RectangularSpell = exports.RadialSpell = void 0;
var pixi_js_1 = require("pixi.js");
var particle_emitter_1 = require("@pixi/particle-emitter");
var app_1 = require("../../app");
var spellFX_1 = require("../../VFX/spellFX");
var RadialSpell = function (_a) {
    var position = _a.position, _b = _a.offset, offset = _b === void 0 ? { x: 0, y: 0 } : _b, _c = _a.growth, growth = _c === void 0 ? 0.5 : _c, _d = _a.startSize, startSize = _d === void 0 ? 0 : _d, _e = _a.endSize, endSize = _e === void 0 ? 50 : _e, color = _a.color, _f = _a.canBeHeld, canBeHeld = _f === void 0 ? false : _f, onComplete = _a.onComplete, successCondition = _a.successCondition, onSuccess = _a.onSuccess;
    var spriteContainer = app_1.appService.spriteContainer, particleContainer = app_1.appService.particleContainer, physicsUpdate = app_1.appService.physicsUpdate;
    var emitter = null;
    var casting = true;
    var size = startSize;
    var circle = new pixi_js_1.Graphics();
    var updateTelegraph = function () {
        var fill = !successCondition || successCondition(size) ? color : "FFAAAA";
        circle.clear();
        circle.lineStyle({ width: 2, color: fill });
        circle.beginFill(fill, 0.3);
        circle.drawCircle(position.x + offset.x, position.y + offset.y, size);
        circle.endFill();
    };
    spriteContainer.addChild(circle);
    var updateSpell = function () {
        if (size < endSize) {
            size += growth;
            updateTelegraph();
        }
        else if (!canBeHeld) {
            resolveSpell();
        }
        return size;
    };
    var growCircleLoop$ = physicsUpdate.subscribe(updateSpell);
    var resolveSpell = function () {
        if (!successCondition || successCondition(size)) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(size);
            emitter = new particle_emitter_1.Emitter(particleContainer, (0, spellFX_1.explosion)({ x: position.x, y: position.y + position.height / 2, color: color, speed: size * 4 }));
            emitter.playOnceAndDestroy();
        }
        onComplete === null || onComplete === void 0 ? void 0 : onComplete(size);
        cancelSpell();
    };
    var cancelSpell = function () {
        growCircleLoop$.unsubscribe();
        casting = false;
        circle.destroy();
    };
    return { casting: casting, resolveSpell: resolveSpell, cancelSpell: cancelSpell };
};
exports.RadialSpell = RadialSpell;
// telegraphed rectangular spell
var RectangularSpell = function (_a) {
    var position = _a.position, _b = _a.offset, offset = _b === void 0 ? { x: 0, y: 0 } : _b, _c = _a.growth, growth = _c === void 0 ? 0.5 : _c, _d = _a.startSize, startSize = _d === void 0 ? 0 : _d, _e = _a.endSize, endSize = _e === void 0 ? 100 : _e, _f = _a.height, height = _f === void 0 ? 30 : _f, _g = _a.color, color = _g === void 0 ? 0xaa5555 : _g, _h = _a.canBeHeld, canBeHeld = _h === void 0 ? false : _h, onComplete = _a.onComplete, target = _a.target;
    var UIContainer = app_1.appService.UIContainer, physicsUpdate = app_1.appService.physicsUpdate;
    var emitter = null;
    var casting = true;
    var width = startSize;
    var container = new pixi_js_1.Container();
    var bg = new pixi_js_1.Graphics();
    var rect = new pixi_js_1.Graphics();
    var updateTelegraph = function () {
        container.position = position;
        container.pivot = position;
        bg.clear();
        bg.lineStyle({ width: 2, color: color });
        bg.beginFill(color, 0.2);
        bg.drawRect(position.x - offset.x, position.y - offset.y - height / 2, endSize, height);
        bg.endFill();
        rect.clear();
        rect.beginFill(color, 0.6);
        rect.drawRect(position.x - offset.x, position.y - offset.y - height / 2, width, height);
        rect.endFill();
    };
    container.addChild(bg);
    container.addChild(rect);
    UIContainer.addChild(container);
    var updateSpell = function () {
        if (width < endSize) {
            width += growth;
            updateTelegraph();
        }
        else if (!canBeHeld) {
            resolveSpell();
        }
        return width;
    };
    var growSpellUpdate$ = physicsUpdate.subscribe(updateSpell);
    var resolveSpell = function () {
        onComplete(width);
        cancelSpell();
    };
    var cancelSpell = function () {
        growSpellUpdate$.unsubscribe();
        casting = false;
        container.destroy();
    };
    return { casting: casting, resolveSpell: resolveSpell, cancelSpell: cancelSpell };
};
exports.RectangularSpell = RectangularSpell;
var CastBar = function (_a) {
    var sprite = _a.sprite, onComplete = _a.onComplete, onSuccess = _a.onSuccess, castTime = _a.castTime;
    var growth = 100 / (castTime * 60);
    var handleComplete = function (endWidth) {
        if (endWidth >= 95) {
            onSuccess();
        }
        onComplete();
    };
    return (0, exports.RectangularSpell)({
        position: sprite,
        offset: { x: sprite.width, y: 50 },
        height: 20,
        onComplete: handleComplete,
        growth: growth,
    });
};
exports.CastBar = CastBar;
var SemiCircleSpell = function () {
};
